module.exports = __webpack_public_path__ + "img/b2c0d3533a4e29b04ed99c3a8b668561.svg";